/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _posted_ago_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Posté il y a ' },
        { type: 1, value: 'date' },
    ],
    'fr',
);

export function posted_ago(args: { date: string }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _posted_ago_fr.format(args) as unknown as string;
    }

    return _posted_ago_fr.format(args) as unknown as string;
}

const _posted_date_fr = new IntlMessageFormat(
    [
        { type: 0, value: 'Posté le ' },
        { type: 1, value: 'date' },
    ],
    'fr',
);

export function posted_date(args: { date: string }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _posted_date_fr.format(args) as unknown as string;
    }

    return _posted_date_fr.format(args) as unknown as string;
}

const _badge_experience_years_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'enum',
            options: {
                from_0_to_2: { value: [{ type: 0, value: '- de 2 ans d’expérience' }] },
                from_2_to_5: {
                    value: [{ type: 0, value: 'de 2 ans à 5 ans d’expérience' }],
                },
                from_0_plus: { value: [{ type: 0, value: 'Sans expérience accepté' }] },
                from_1_plus: { value: [{ type: 0, value: '+ de 1 an d’expérience' }] },
                from_2_plus: { value: [{ type: 0, value: '+ de 2 ans d’expérience' }] },
                from_3_plus: { value: [{ type: 0, value: '+ de 3 ans d’expérience' }] },
                from_4_plus: { value: [{ type: 0, value: '+ de 4 ans d’expérience' }] },
                from_5_plus: { value: [{ type: 0, value: '+ de 5 ans d’expérience' }] },
                from_6_plus: { value: [{ type: 0, value: '+ de 6 ans d’expérience' }] },
                from_7_plus: { value: [{ type: 0, value: '+ de 7 ans d’expérience' }] },
                from_8_plus: { value: [{ type: 0, value: '+ de 8 ans d’expérience' }] },
                from_9_plus: { value: [{ type: 0, value: '+ de 9 ans d’expérience' }] },
                from_10_plus: { value: [{ type: 0, value: '+ de 10 ans d’expérience' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function badge_experience_years(
    args: {
        enum:
            | 'from_0_plus'
            | 'from_0_to_2'
            | 'from_10_plus'
            | 'from_1_plus'
            | 'from_2_plus'
            | 'from_2_to_5'
            | 'from_3_plus'
            | 'from_4_plus'
            | 'from_5_plus'
            | 'from_6_plus'
            | 'from_7_plus'
            | 'from_8_plus'
            | 'from_9_plus';
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _badge_experience_years_fr.format(args) as unknown as string;
    }

    return _badge_experience_years_fr.format(args) as unknown as string;
}

const _work_time_enum_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'enum',
            options: {
                full_time: { value: [{ type: 0, value: 'Temps complet' }] },
                part_time: { value: [{ type: 0, value: 'Mi-temps' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function work_time_enum(
    args: { enum: 'full_time' | 'part_time' },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _work_time_enum_fr.format(args) as unknown as string;
    }

    return _work_time_enum_fr.format(args) as unknown as string;
}

const _remote_work_enum_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'enum',
            options: {
                full: { value: [{ type: 0, value: ' Télétravail complet ' }] },
                partial: { value: [{ type: 0, value: ' Télétravail partiel ' }] },
                occasional: { value: [{ type: 0, value: ' Télétravail occasional ' }] },
                none: { value: [{ type: 0, value: ' Sans télétravail ' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function remote_work_enum(
    args: { enum: 'full' | 'none' | 'occasional' | 'partial' },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _remote_work_enum_fr.format(args) as unknown as string;
    }

    return _remote_work_enum_fr.format(args) as unknown as string;
}

const _contract_type_enum_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'enum',
            options: {
                freelance: { value: [{ type: 0, value: ' Freelance ' }] },
                cdd: { value: [{ type: 0, value: ' CDD ' }] },
                cdi: { value: [{ type: 0, value: ' CDI ' }] },
                interim: { value: [{ type: 0, value: ' Intérim ' }] },
                apprenticeship_alternation: {
                    value: [{ type: 0, value: ' Apprentissage / Alternance ' }],
                },
                internship: { value: [{ type: 0, value: ' Stage ' }] },
                volunteering: { value: [{ type: 0, value: ' Bénévolat ' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function contract_type_enum(
    args: {
        enum:
            | 'apprenticeship_alternation'
            | 'cdd'
            | 'cdi'
            | 'freelance'
            | 'interim'
            | 'internship'
            | 'volunteering';
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contract_type_enum_fr.format(args) as unknown as string;
    }

    return _contract_type_enum_fr.format(args) as unknown as string;
}

const _nb_job_offers_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'nb',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: " offre d'emploi" }] },
                other: { value: [{ type: 7 }, { type: 0, value: " offres d'emploi" }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function nb_job_offers(args: { nb: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _nb_job_offers_fr.format(args) as unknown as string;
    }

    return _nb_job_offers_fr.format(args) as unknown as string;
}

const _salary_period_enum_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'period',
            options: {
                hour: { value: [{ type: 0, value: 'heure' }] },
                day: { value: [{ type: 0, value: 'jour' }] },
                month: { value: [{ type: 0, value: 'mois' }] },
                year: { value: [{ type: 0, value: 'an' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function salary_period_enum(
    args: { period: 'day' | 'hour' | 'month' | 'year' },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _salary_period_enum_fr.format(args) as unknown as string;
    }

    return _salary_period_enum_fr.format(args) as unknown as string;
}

const _create_job_offer_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Créer une annonce emploi' }],
    'fr',
);

export function create_job_offer(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _create_job_offer_fr.format(args) as unknown as string;
    }

    return _create_job_offer_fr.format(args) as unknown as string;
}

const _edit_job_offer_fr = new IntlMessageFormat(
    [{ type: 0, value: "Editer l'annonce emploi" }],
    'fr',
);

export function edit_job_offer(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _edit_job_offer_fr.format(args) as unknown as string;
    }

    return _edit_job_offer_fr.format(args) as unknown as string;
}

const _prompt_delete_fr = new IntlMessageFormat(
    [{ type: 0, value: "Voulez-vous vraiment supprimer cette annonce d'emploi ?" }],
    'fr',
);

export function prompt_delete(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _prompt_delete_fr.format(args) as unknown as string;
    }

    return _prompt_delete_fr.format(args) as unknown as string;
}

const _job_offer_deleted_fr = new IntlMessageFormat(
    [{ type: 0, value: "Votre annonce d'emploi a été supprimée avec succès" }],
    'fr',
);

export function job_offer_deleted(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _job_offer_deleted_fr.format(args) as unknown as string;
    }

    return _job_offer_deleted_fr.format(args) as unknown as string;
}

const _add_in_bookmarks_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ajouter à mes favoris' }],
    'fr',
);

export function add_in_bookmarks(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _add_in_bookmarks_fr.format(args) as unknown as string;
    }

    return _add_in_bookmarks_fr.format(args) as unknown as string;
}

const _share_job_offer_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce" }],
    'fr',
);

export function share_job_offer(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_fr.format(args) as unknown as string;
    }

    return _share_job_offer_fr.format(args) as unknown as string;
}

const _share_job_offer_on_gao_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce sur GAO" }],
    'fr',
);

export function share_job_offer_on_gao(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_on_gao_fr.format(args) as unknown as string;
    }

    return _share_job_offer_on_gao_fr.format(args) as unknown as string;
}

const _share_job_offer_on_facebook_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce sur GAO" }],
    'fr',
);

export function share_job_offer_on_facebook(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_on_facebook_fr.format(args) as unknown as string;
    }

    return _share_job_offer_on_facebook_fr.format(args) as unknown as string;
}

const _share_job_offer_on_twitter_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce sur X/Twitter" }],
    'fr',
);

export function share_job_offer_on_twitter(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_on_twitter_fr.format(args) as unknown as string;
    }

    return _share_job_offer_on_twitter_fr.format(args) as unknown as string;
}

const _share_job_offer_on_linkedin_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce sur Linkedin" }],
    'fr',
);

export function share_job_offer_on_linkedin(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_on_linkedin_fr.format(args) as unknown as string;
    }

    return _share_job_offer_on_linkedin_fr.format(args) as unknown as string;
}

const _share_job_offer_on_whatsapp_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce sur Whatsapp" }],
    'fr',
);

export function share_job_offer_on_whatsapp(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_on_whatsapp_fr.format(args) as unknown as string;
    }

    return _share_job_offer_on_whatsapp_fr.format(args) as unknown as string;
}

const _share_job_offer_on_tiktok_fr = new IntlMessageFormat(
    [{ type: 0, value: "Partager l'annonce sur Tiktok" }],
    'fr',
);

export function share_job_offer_on_tiktok(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_job_offer_on_tiktok_fr.format(args) as unknown as string;
    }

    return _share_job_offer_on_tiktok_fr.format(args) as unknown as string;
}
